import { Theme, createStyles, IconButton, withStyles, MenuItem, Menu, ListItemIcon, Typography } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import React from "react";
import { MeetingSnapshot } from "../../domain/api/meetings/MeetingSnapshot";
import { PredefinedSnapshotType } from "../../domain/api/meetings/PredefinedSnapshotType";
import meetingSnapshotDataService from "../../services/api/MeetingSnapshotDataService";

import i18n from "../../services/localization/i18n";
import { IContextStoreProps } from "../../stores/IContextStoreProps";
import { PredefinedStoreName } from "../enums/PredefinedStoreName";
import AppIcon from "../shared/AppIcon";
import { AppIconType } from "../shared/AppIconType";


const styles = (theme: Theme) => createStyles({
    icon: {

    },
    root: {
        padding: theme.spacing()
    }
});


interface ISnapshotVisibilityProps {
    classes: {
        icon: string;
        root: string;
    };
    snapshot: MeetingSnapshot;
}

interface ISnapshotTypeState {
    anchorEl?: HTMLButtonElement;
}


@inject(PredefinedStoreName.CONTEXT)
@observer
class SnapshotType extends React.Component<ISnapshotVisibilityProps & IContextStoreProps, ISnapshotTypeState> {


    /**
     * Creates an instance of SnapshotType.
     * @param {(ISnapshotVisibilityProps & IContextStoreProps)} props
     * @memberof SnapshotType
     */
    constructor(props: ISnapshotVisibilityProps & IContextStoreProps) {
        super(props);

        this.state = {

        }
    }

    public render() {

        const { anchorEl } = this.state;

        const { snapshotType } = this.props.snapshot;

        return <>
            { snapshotType === PredefinedSnapshotType.PERSONAL && this.renderPersonalType() }
            { snapshotType === PredefinedSnapshotType.TEAM && this.renderTeamType() }
            { snapshotType === PredefinedSnapshotType.ALL_PARTICIPANTS && this.renderPublicType() }

            <Menu anchorEl={anchorEl} keepMounted={true} open={Boolean(anchorEl)}>
                <MenuItem   title={i18n.t("snapshot_personal_title")}
                            selected={ snapshotType === PredefinedSnapshotType.PERSONAL}
                            onClick={() => this.selectSnapshotType(PredefinedSnapshotType.PERSONAL)}>
                    <ListItemIcon>
                        <AppIcon icon={AppIconType.VisibilityOff} />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        { i18n.t("snapshot_personal_value") }
                    </Typography>
                </MenuItem>
                <MenuItem   title={i18n.t("snapshot_team_title")}
                            selected={ snapshotType === PredefinedSnapshotType.TEAM}
                            onClick={() => this.selectSnapshotType(PredefinedSnapshotType.TEAM)}>
                    <ListItemIcon>
                        <AppIcon icon={AppIconType.GroupWork} />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        { i18n.t("snapshot_team_value") }
                    </Typography>
                </MenuItem>                
                <MenuItem   title={i18n.t("snapshot_public_title")}
                            selected={ snapshotType === PredefinedSnapshotType.ALL_PARTICIPANTS}
                            onClick={() => this.selectSnapshotType(PredefinedSnapshotType.ALL_PARTICIPANTS)}>
                    <ListItemIcon>
                        <AppIcon icon={AppIconType.VisibilityOn} />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        { i18n.t("snapshot_public_value") }
                    </Typography>
                </MenuItem>                
            </Menu>
        </>
    }

    public selectSnapshotType = (snapshotType: PredefinedSnapshotType) => {
        const { snapshot } = this.props;
        const { addOrUpdateSnapshot } = this.props.contextStore!;

        const updatedSnapshot = {...snapshot};
        updatedSnapshot.snapshotType = snapshotType;

        this.setState({
            anchorEl: undefined
        });

        meetingSnapshotDataService.updateSnapshotAsync(updatedSnapshot)
            .then(snapshot => {
                addOrUpdateSnapshot(snapshot);
            });
    }

    public renderPersonalType = () => {

        const { icon } = this.props.classes;

        return <>
            <IconButton className={ icon }
                    title = { i18n.t("snapshot_personal_title") }
                    onClick={this.showTypeSelector}>
                <AppIcon icon={AppIconType.VisibilityOff} />
            </IconButton>
           
        </>
    }

    public renderTeamType = () => {

        const { icon } = this.props.classes;

        return <IconButton className={ icon }
                    title = { i18n.t("snapshot_team_title") }
                    onClick={this.showTypeSelector}>
                <AppIcon icon={AppIconType.GroupWork} />
        </IconButton>
    }

    
    public renderPublicType = () => {

        const { icon } = this.props.classes;

        return <IconButton className={ icon }
                    title = { i18n.t("snapshot_public_title") }
                    onClick={this.showTypeSelector}>
                <AppIcon icon={AppIconType.VisibilityOn} />
        </IconButton>
    }

    private showTypeSelector = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({
            anchorEl: e.currentTarget
        })
    }
}

export default withStyles(styles)(SnapshotType);


